import axiosInstance from '../Config/AxiosInstance';

const PREFIX = `/clinic/doctor`;

// Old implementation - commented out as backend sends all items by default
// export const listAll = (
//   facilities,
//   name,
//   pageSize,
//   pageNo,
//   sortFitler,
//   sortOrder
// ) => {
//   let url =
//     PREFIX +
//     `?name=${encodeURIComponent(
//       name
//     )}&sortKey=${sortFitler}&page=${pageNo}&size=${pageSize}&sortOrder=${sortOrder}`;
//
//   if (facilities.length > 0) {
//     url += `&facilityIds=${facilities}`;
//   }
//
//   return axiosInstance.get(url);
// };

// Simplified implementation - backend sends all items without pagination params
export const listAll = () => {
  return axiosInstance.get(PREFIX);
};

export const saveDoctor = data => {
  return axiosInstance.post(PREFIX, data);
};

export const editDoctor = (data, params = {}) => {
  return axiosInstance.put(PREFIX, data, { params });
};

export const deleteReviewer = id => {
  return axiosInstance.delete(PREFIX + `/${id}`);
};

export const fetchEhrDoctors = () => {
  return axiosInstance.get(PREFIX + '/ehr');
};
export const findPatientMoreDetails = (facilityId, patientId, date = '') => {
  const dateParam = date ? `&date=${date}` : '';
  return axiosInstance.get(
    PREFIX + `/${facilityId}/patient_moredetails?patientId=${patientId}${dateParam}`
  );
};
export const getListofJobsForMyJobsTabDoctor = (
  pageNo,
  size,
  sortKey,
  sortOrder,
  status,
  searchValue
) => {
  return axiosInstance.get(
    PREFIX +
      `/my-jobs?page=${pageNo}&size=${size}&sortKey=${sortKey}&sortOrder=${sortOrder}&status=${status}&searchValue=${searchValue}`
  );
};
export const completeDoctorJob = (jobId, sessionId, sections, timeZoneConfig) => {
  const body = { sections };
  if (timeZoneConfig) body.timeZoneConfig = timeZoneConfig;
  return axiosInstance.post(
    PREFIX + `/complete-job?jobId=${jobId}&sessionId=${sessionId}`,
    body
  );
};

export const getPatientLabReports = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/patient/lab-reports?facilityId=${facilityId}&patientId=${patientId}`
  );
};
export const getLabReports = (patientId, facilityId) => {
  return axiosInstance.get(
    PREFIX + `/patient/lab-reports?patientId=${patientId}&facilityId=${facilityId}`
  );
};
export const getMedications = (patientId, facilityId) => {
  return axiosInstance.get(
    PREFIX + `/patient/medication?patientId=${patientId}&facilityId=${facilityId}`
  );
};

export const getPatientMedications = (facilityId, patientId) => {
  return axiosInstance.get(
    PREFIX + `/patient/medication?facilityId=${facilityId}&patientId=${patientId}`
  );
};
export const getPreviousNotes = (patientId, facilityId, page = 0, size = 10) => {
  return axiosInstance.get(
    PREFIX + `/patient/${patientId}/previous-notes?facilityId=${facilityId}&page=${page}&size=${size}`
  );
};
